<script lang="ts">
  import InfoButton from "./InfoButton.svelte";
</script>

<InfoButton iconSize={18} class="text-Neutral700 z-10"
  >No Swedish personal number? No problem! Just reach out to the electricity network company in your
  area to get set up. If you live within Skellefteå Kraft’s network area, you can
  <a href="/kundservice/kontakt/" class="text-Violet400 whitespace-nowrap"
    >contact our customer service</a
  > for assistance.</InfoButton
>
